import classNames from "classnames";
import cssButtonStyles from "src/components/button/Button.module.css";
import styles from "./StyleCentered.module.css";

//#region [Props]
type StyleCenteredProps = {
};
//#endregion

//#region [Component]
export default function StyleCentered(props: any) {
    return <p className={classNames(styles.SStyleCentered)}>{props.children}</p>;
}
//#endregion
